import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { enumMarineInsuranceCommodity } from '@app/data-layer/enums/marine-insurance';
import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { MarineInsuranceManagementModel, MarineInsuranceModel } from '@data-layer/models/marine-insurance';
import { DateTimezoneService } from '@services/date-timezone.service';

@Component({
  selector: 'app-marine-insurance-quote-view-data',
  templateUrl: './marine-insurance-quote-view-data.component.html',
  styleUrls: ['./marine-insurance-quote-view-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceQuoteViewDataComponent {
  @Input() public marineInsurance: MarineInsuranceModel | MarineInsuranceManagementModel;
  @Input() public isShowUpdatedInsuredValue: boolean;
  @Input() public isShowUpdatedDate: boolean;
  @Input() public isShowCertificate: boolean = true;
  @Input() public isShowDepartureDate: boolean = true;

  constructor(private dateTimeZoneService: DateTimezoneService) {}

  public DEFAULT_CURRENCY_CODE: typeof DEFAULT_CURRENCY_CODE = DEFAULT_CURRENCY_CODE;

  public get isShowCertificateData(): boolean {
    return this.isShowCertificate && !!this.marineInsurance?.certificate?.issueDate;
  }

  public get isVehiclesCommodity(): boolean {
    return this.marineInsurance?.insuredValue?.commodity?.id === enumMarineInsuranceCommodity.VEHICLES;
  }

  public get manufactureDate(): string {
    //Conversion of year string into full date string with year assuming we convert date to year only string upon saving
    const originalManufactureDate = this.marineInsurance?.updatedManufactureDate || this.marineInsurance?.manufactureDate;

    if (!originalManufactureDate) {
      return;
    }

    const newManufactureDate = this.dateTimeZoneService.formatInUserTZ(`${originalManufactureDate}-02-02`);
    return newManufactureDate;
  }
}
